import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [internshipDropdown, setInternshipDropdown] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location]);
  useEffect(() => setInternshipDropdown(false), [location]);

  const links = [
    { to: "/", label: "Home" },
    { to: "/projects", label: "Projects" },
    { to: "/about", label: "About" },
    { to: "/verify", label: "Verify Certificate" },
    { to: "/contact", label: "Contact" },
  ];

  const internshipLinks = [
    { to: "/internship", label: "Internship Info" },
    { to: "/student/login", label: "Internship Tasks" },
  ];

  const navStyle = {
    position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
    padding: "0 24px",
    background: scrolled ? "rgba(10,10,15,0.95)" : "transparent",
    backdropFilter: scrolled ? "blur(12px)" : "none",
    borderBottom: scrolled ? "1px solid #2a2a3a" : "none",
    transition: "all 0.3s",
  };

  return (
    <nav style={navStyle}>
      <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", height: 64 }}>
        <Link to="/" style={{ textDecoration: "none", flexShrink: 0 }}>
          <span style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(14px, 4vw, 20px)", color: "#fff" }}>
            Ariyom Tech<span style={{ color: "var(--accent)" }}> Solutions</span>
          </span>
        </Link>

        <div style={{ display: "flex", gap: 8, alignItems: "center" }} className="desktop-nav">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              style={{
                padding: "6px 16px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
                color: location.pathname === l.to ? "var(--accent)" : "var(--text)",
                background: location.pathname === l.to ? "rgba(0,229,255,0.08)" : "transparent",
                textDecoration: "none",
                transition: "all 0.2s",
              }}
            >
              {l.label}
            </Link>
          ))}

          {/* Internship Dropdown */}
          <div style={{ position: "relative" }}>
            <button
              onClick={() => setInternshipDropdown(!internshipDropdown)}
              style={{
                padding: "6px 16px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
                color: ["/internship", "/student/login"].includes(location.pathname) ? "var(--accent)" : "var(--text)",
                background: ["/internship", "/student/login"].includes(location.pathname) ? "rgba(0,229,255,0.08)" : "transparent",
                border: "none",
                background: "none",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onMouseEnter={() => setInternshipDropdown(true)}
              onMouseLeave={() => setInternshipDropdown(false)}
            >
              🎓 Internship {internshipDropdown ? "▼" : "▶"}
            </button>
            {internshipDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "var(--bg2)",
                  border: "1px solid var(--border)",
                  borderRadius: 8,
                  minWidth: 160,
                  marginTop: 4,
                  zIndex: 1000,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                }}
                onMouseEnter={() => setInternshipDropdown(true)}
                onMouseLeave={() => setInternshipDropdown(false)}
              >
                {internshipLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    style={{
                      display: "block",
                      padding: "10px 16px",
                      color: location.pathname === link.to ? "var(--accent)" : "var(--text)",
                      textDecoration: "none",
                      fontSize: 14,
                      borderBottom: "1px solid var(--border)",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "rgba(0,229,255,0.08)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "transparent";
                    }}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link to="/admin/dashboard" className="btn btn-primary" style={{ marginLeft: 8, padding: "7px 18px", borderRadius: 8, fontSize: 13, textDecoration: "none" }}>
            Admin
          </Link>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          style={{ background: "none", border: "none", color: "var(--text)", fontSize: 26, display: "none", cursor: "pointer", padding: "4px 8px", flexShrink: 0 }}
          className="hamburger"
        >
          {menuOpen ? "x" : "="}
        </button>
      </div>

      {menuOpen && (
        <div style={{
          background: "var(--bg2)",
          borderTop: "1px solid var(--border)",
          padding: "16px 24px",
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}>
          {links.map((l) => (
            <Link key={l.to} to={l.to} style={{
              padding: "10px 14px", borderRadius: 8, color: "var(--text)",
              textDecoration: "none", fontSize: 15,
            }}>
              {l.label}
            </Link>
          ))}
          {/* Mobile Internship Menu */}
          <div style={{ paddingTop: 8, borderTop: "1px solid var(--border)" }}>
            <button
              onClick={() => setInternshipDropdown(!internshipDropdown)}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                color: "var(--text)",
                background: "none",
                border: "none",
                textAlign: "left",
                fontSize: 15,
                cursor: "pointer",
              }}
            >
              🎓 Internship {internshipDropdown ? "▼" : "▶"}
            </button>
            {internshipDropdown && (
              <div style={{ paddingLeft: 14 }}>
                {internshipLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    style={{
                      display: "block",
                      padding: "8px 12px",
                      color: location.pathname === link.to ? "var(--accent)" : "var(--text)",
                      textDecoration: "none",
                      fontSize: 14,
                    }}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
          <Link to="/admin/dashboard" style={{ padding: "10px 14px", color: "var(--accent)", textDecoration: "none", fontSize: 15 }}>
            Admin Dashboard
          </Link>
        </div>
      )}

      <style>{`
        @media (max-width: 640px) {
          .desktop-nav { display: none !important; }
          .hamburger { display: block !important; }
        }
      `}</style>
    </nav>
  );
}